import React, { useEffect, useRef, useState } from "react";
import "../../index.css";
import NotesModal from "./Notes";
import RequestSentDetailsDS from "../../DataServices/RequestSentDetailsDS";
import { useCustomContext } from "../CustomComponents/CustomComponents";
import { ContactFlowVersionSummary$ } from "@aws-sdk/client-connect";
import { insertLog } from "../Logs/InsertLog";

 // const CONNECT_INSTANCE_URL = "https://ws0122-stage.my.connect.aws";

function GlobalCCP() {
    // ─── REFS ────────────────────────────────────
    const ccpRef = useRef(null);
    const agentRef = useRef(null);
    const activeContactRef = useRef(null);
    const availableStateRef = useRef(null);
    const [contactId, setContactId] = useState("");
    const requestAgency = new RequestSentDetailsDS();
    const { showAlert, stopHudRotation, hud, showToast } = useCustomContext();
    const useremail = localStorage.getItem("email");
    const userName = useremail?.split("@")[0];

    // ─── STATE ───────────────────────────────────
    const [open, setOpen] = useState(false);
    const [showNotesModal, setShowNotesModal] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [notes, setNotes] = useState("");
    const [selectedAgency, setSelectedAgency] = useState("");
    const [datasetID, setDatasetID] = useState('');
    const [selectedDataset, setSelectedDataset] = useState("");
    const [agencyID, setAgencyID] = useState('');
    const [isRinging, setIsRinging] = useState(false);
    const [agencies, setAgencies] = useState([]);

    const [isModalDisabled, setIsModalDisabled] = useState(false);

    // ─── FETCH AGENCIES ON MODAL OPEN ────────────
    // Runs whenever the notes modal becomes visible so phoneNumber is already set.
    useEffect(() => {
        if (showNotesModal) {
            fetchAgenciesWithPhoneNumber();
        }
    }, [showNotesModal]);

    // ─── CCP INITIALIZATION ──────────────────────
    useEffect(() => {
        if (!window.connect || !ccpRef.current) return;
        if (window.ccpInitialized) return;

        window.ccpInitialized = true;

        window.connect.core.initCCP(ccpRef.current, {
            ccpUrl: `${process.env.REACT_APP_CONNECT_INSTANCE_URL}/ccp-v2/`,
            loginPopup: true,
            loginPopupAutoClose: true,
            loginOptions: { autoClose: true, height: 600, width: 400 },
            softphone: { allowFramedSoftphone: true },
        });

        window.connect.agent((agent) => {
            console.log("✅ Agent Initialized");

            agentRef.current = agent;

            const states = agent.getAgentStates();
            console.log("========== AGENT STATES ==========");
            states.forEach((state, index) => console.log(`${index + 1}. ${state.name}`));

            availableStateRef.current = states.find(
                (state) => state.type === window.connect.AgentStateType.ROUTABLE
            );

            // wrapupStateRef.current = states.find(
            //     (state) => state.name === "After Call Work"
            // );

            // console.log("Available State:", availableStateRef.current?.name);
            // console.log("Wrapup State:", wrapupStateRef.current?.name);

            window.connect.contact((contact) => {
                console.log("🔔 Contact Event");

                const capturePhoneNumber = () => {
                    try {
                        const endpoint = contact.getInitialConnection()?.getEndpoint();
                        const incomingNumber = endpoint?.phoneNumber || endpoint?.endpointARN || "Unknown";
                        setPhoneNumber(incomingNumber);
                        console.log("📞 Number:", incomingNumber);
                    } catch (err) {
                        console.error("Failed capturing number:", err);
                    }
                };

                contact.onConnecting(() => {
                    console.log("📲 Connecting");
                    setOpen(true);
                    setIsRinging(true);
                    capturePhoneNumber();
                    activeContactRef.current = contact;
                });

                contact.onIncoming(() => {
                    console.log("📲 Incoming");
                    setOpen(true);
                    setIsRinging(true);
                    capturePhoneNumber();
                });

                contact.onAccepted(() => {
                    console.log("✅ Accepted");
                    setIsRinging(false);
                    capturePhoneNumber();
                    setContactId(contact.getContactId());
                    setShowNotesModal(true)
                    activeContactRef.current = contact;
                });

                contact.onConnected(() => {
                    console.log("✅ Connected");
                    setIsRinging(false);
                    capturePhoneNumber();
                    activeContactRef.current = contact;
                });

                contact.onEnded(() => {
                    console.log("📴 Ended");
                    setIsRinging(false);

                    setToAvailable();
                    // const wrapupState = wrapupStateRef.current;

                    // if (!agentRef.current || !wrapupState) {
                    //     console.error("Wrapup state missing");
                    //     return;
                    // }

                    // agentRef.current.setState(wrapupState, {
                    //     success: () => console.log("✅ Wrapup set"),
                    //     failure: (err) => console.error("Wrapup failed:", err),
                    // });
                });
            });
        });
    }, []);

    // ─── FETCH AGENCIES & MATCH PHONE NUMBER ─────
    const fetchAgenciesWithPhoneNumber = async () => {
        try {
            const response = await requestAgency.WS_Inbound_Calls_Agencies_Get({});
            const body = response.data.body;
            console.log("Body of code:", body)
            // SUCCESS
            if (
                response.data.statusCode === 200 &&
                body?.success &&
                Array.isArray(body.data)
            ) {
                const collection = body.data;

                // Normalize incoming phone number
                const normalizedPhone = phoneNumber
                    .replace(/^\+1/, "")  // 1. Remove "+1" only if it is at the very start
                    .replace(/\D/g, "");  // 2. Then remove any remaining non-digits

                // Match agencies by phone number
                const matchedAgencies =
                    collection.filter((agency) =>
                        agency.agencyPhoneNumbers?.some(
                            (entry) =>
                                entry.number === normalizedPhone
                        )
                    );
                console.log("matched agencies", matchedAgencies);
                // Store only matched agencies
                setAgencies(matchedAgencies);

                insertLog(
                    `${userName} fetched agencies for inbound call`,
                    0,
                    localStorage.getItem("email"),
                    hud,
                    stopHudRotation,
                    showAlert,
                    contactId || '',
                    'GET',
                    'WS_Inbound_Calls_Agencies_Get',
                    'SUCCESS',
                    ''
                );

                // ONE MATCH
                if (matchedAgencies.length === 1) {
                    const agency = matchedAgencies[0];

                    setSelectedAgency(agency.agencyName);
                    setAgencyID(agency.agencyID);

                    setDatasetID(agency.datasetID);
                    setSelectedDataset(agency.datasetID);
                    console.log(
                        "✅ Agency auto-selected:",
                        matchedAgencies[0]
                            .agencyDisplayName
                    );
                }

                // MULTIPLE MATCHES
                else if (matchedAgencies.length > 1) {
                    console.log("matched agencies", matchedAgencies);
                    setIsModalDisabled(true);

                    showToast({
                        message: "Multiple agencies found for this Number. please select your agency."
                    });

                    setTimeout(() => {
                        setIsModalDisabled(false);
                    }, 3000); // match toast duration
                }
                // NO MATCH
                else {
                    console.log(
                        "No matching agency found"
                    );
                }
            }

            // FAILURE
            else {
                showAlert(
                    body?.message ||
                    "No agencies found",
                    [
                        {
                            label: "OK",
                            onClick: () => { },
                            color:
                                "var(--buttonColor)",
                        },
                    ]
                );
                insertLog(
                    `${userName} failed to fetch agencies for inbound call`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    contactId || '',
                    'GET',
                    'WS_Inbound_Calls_Agencies_Get',
                    'FAILED',
                    'No agencies found'
                );
            }
        } catch (err) {
            console.error(err);

            insertLog(
                `${userName} failed to fetch agencies for inbound call`,
                0,
                localStorage.getItem("email"),
                hud,
                stopHudRotation,
                showAlert,
                contactId || '',
                'GET',
                'WS_Inbound_Calls_Agencies_Get',
                'FAILED',
                err.message
            );

            showAlert(
                err.message ||
                "Something went wrong while fetching Agencies.",
                [
                    {
                        label: "OK",
                        onClick: () => { },
                        color:
                            "var(--buttonColor)",
                    },
                ]
            );
        }
    };

    // ─── SET AGENT AVAILABLE ─────────────────────
    const setToAvailable = () => {
        const agent = agentRef.current;
        const availableState = availableStateRef.current;

        if (!agent || !availableState) {
            console.error("Available state missing");
            return;
        }

        agent.setState(availableState, {
            success: () => console.log(`✅ Changed to ${availableState.name}`),
            failure: (err) => console.error("Failed setting available:", err),
        });
    };

    // ─── CLEAR NOTES ─────────────────────────────
    const clearNotes = () => setNotes("");

    // ─── SAVE NOTES ──────────────────────────────
    const handleSaveNotes = async () => {
        hud("Please wait")
        try {
            const payload = {
                called_from: phoneNumber,
                agent_email: localStorage.getItem("email") || "",
                caller_id: contactId,
                called_to: "+1 877-424-6963",
                datasetID: datasetID,
                agency: selectedAgency,
                agencyID: agencyID,
                isIncoming: true,
                notes,
                createdAt: new Date().toISOString(),
            };

            console.log("Saving Notes:", payload);
            const response =
                await requestAgency.AC_Incoming_Call_Info_ADD(
                    payload
                );

            const body =
                typeof response.data.body === "string"
                    ? JSON.parse(response.data.body)
                    : response.data.body;
            console.log("response:", response)
            if (response.data.statusCode === 200) {

                insertLog(
                    `${userName} saved inbound call notes for phone '${phoneNumber}' and agency '${selectedAgency}'`,
                    0,
                    localStorage.getItem("email"),
                    hud,
                    stopHudRotation,
                    showAlert,
                    contactId || '',
                    'ADD',
                    'AC_Incoming_Call_Info_ADD',
                    'SUCCESS',
                    ''
                );

                setShowNotesModal(false);
                stopHudRotation();
                setNotes("");
                setSelectedAgency("");
                setPhoneNumber("");
                setAgencies([]);
                setToAvailable();
                setSelectedDataset("");
                setDatasetID("");
                setAgencyID("");
                setContactId("");
            } else if (response.data.statusCode === 400) {
                stopHudRotation();
                showAlert(body?.message || "Invalid request. Please check your input.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
                insertLog(
                    `${userName} failed to save inbound call notes for phone '${phoneNumber}' and agency '${selectedAgency}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    contactId || '',
                    'ADD',
                    'AC_Incoming_Call_Info_ADD',
                    'FAILED',
                    'Invalid request'
                );
            } else {
                stopHudRotation();
                showAlert(body?.message || "Something went wrong. Please try again.", [{ label: "OK", onClick: () => { }, color: 'var(--buttonColor)' }]);
                insertLog(
                    `${userName} failed to save inbound call notes for phone '${phoneNumber}' and agency '${selectedAgency}'`,
                    0,
                    useremail,
                    hud,
                    stopHudRotation,
                    showAlert,
                    contactId || '',
                    'ADD',
                    'AC_Incoming_Call_Info_ADD',
                    'FAILED',
                    'Unable to save inbound call notes'
                );
            }
        } catch (err) {
            stopHudRotation();
            insertLog(
                `${userName} failed to save inbound call notes for phone '${phoneNumber}' and agency '${selectedAgency}'`,
                0,
                localStorage.getItem("email"),
                hud,
                stopHudRotation,
                showAlert,
                contactId || '',
                'ADD',
                'AC_Incoming_Call_Info_ADD',
                'FAILED',
                err.message
            );
            console.error("Save failed:", err);
        }
    };

    const resetNotesModal = () => {
        setNotes("");
        setSelectedAgency("");
        setSelectedDataset("");
        setDatasetID("");
        setAgencyID("");
        setPhoneNumber("");
        setContactId("");
        setAgencies([]);
        setIsModalDisabled(false);
        setShowNotesModal(false);
    };

    // ─── RENDER ──────────────────────────────────
    return (
        <>
            {/* FLOATING CCP BUTTON */}
            <button
                onClick={() => setOpen(!open)}
                className={isRinging ? "call-icon-ringing" : ""}
                style={{
                    position: "fixed",
                    bottom: "10px",
                    right: "10px",
                    zIndex: 10000,
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    border: "none",
                    background: "#ff6b35",
                    color: "#fff",
                    fontSize: "22px",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                }}
            >
                ☎
            </button>

            {/* CCP CONTAINER */}
            <div
                style={{
                    position: "fixed",
                    bottom: "70px",
                    right: "20px",
                    width: open ? "320px" : "0px",
                    height: open ? "580px" : "0px",
                    opacity: open ? 1 : 0,
                    overflow: "hidden",
                    zIndex: 9999,
                    background: "#fff",
                    borderRadius: "12px",
                    boxShadow: open ? "0 5px 30px rgba(0,0,0,0.3)" : "none",
                    transition: "all 0.25s ease",
                }}
            >
                <div ref={ccpRef} style={{ width: "320px", height: "580px" }} />
            </div>

            {/* NOTES MODAL */}
            <NotesModal
                show={showNotesModal}
                phoneNumber={phoneNumber}
                selectedAgency={selectedAgency}
                setDatasetID={setDatasetID}
                setSelectedAgency={setSelectedAgency}
                notes={notes}
                setNotes={setNotes}
                agencies={agencies}
                onClear={clearNotes}
                onSubmit={handleSaveNotes}
                setAgencyID={setAgencyID}
                isDisabled={isModalDisabled}
                selectedDataset={selectedDataset}
                setSelectedDataset={setSelectedDataset}
                onClose={resetNotesModal}
                datasetID={datasetID}
            />
        </>
    );
}

export default GlobalCCP;